import { useRef } from "react";

import { TESTIMONIALS } from "../data/testimonials";
import { TestimonialCard } from "./TestimonialCard";
import { TrustpilotWidget } from "./TrustpilotWidget";

export const TestimonialsSection = () => {
  const carouselRef = useRef<HTMLDivElement>(null);

  return (
    <section
      className={[
        "flex flex-col items-center bg-white",
        "gap-6 py-20",
        "md:gap-10 md:py-24",
        "xl:py-20",
        "2xl:mx-auto 2xl:max-w-[1440px]",
      ].join(" ")}
    >
      <h2 className="max-w-[324px] text-center text-[19px] font-bold leading-[1.2] text-[#0D0D0D] md:max-w-none md:text-[28px]">
        Nos membres en parlent
      </h2>

      <div
        ref={carouselRef}
        className={[
          "flex w-full gap-3 overflow-x-auto",
          "px-4 [justify-content:safe_center]",
          "md:gap-4 md:px-10",
          "xl:px-[120px]",
          "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
        ].join(" ")}
        tabIndex={0}
        aria-label="Carrousel des avis membres"
      >
        {TESTIMONIALS.map((testimonial) => (
          <TestimonialCard key={testimonial.id} testimonial={testimonial} />
        ))}
      </div>

      <TrustpilotWidget trackingSection="widget_deux" />
    </section>
  );
};
